<template>
  <Modal :visible="visible" @close="$emit('close')" title="Dodaj fotografijo">
    <div class="row">
      <div class="col text-center">
        <Camera @captured="capture" v-if="!hasFiles && visible" />
        <img ref="imgEl" style="width: 100%" />
      </div>
    </div>

    <template v-slot:buttons>
      <button class="btn btn-primary me-3" type="button" :disabled="!hasFiles" @click="uploadFiles">
        Naloži fotografijo
      </button>
    </template>
  </Modal>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import dayjs from "dayjs"

import { useAuth } from "../composition-api/useAuth"
import { setError, startLoading, stopLoading } from "./Notification"
import Camera from "./Camera.vue"

defineOptions({ name: "AttachFromCamera" })

const props = defineProps({
  visible: { type: Boolean, default: false },
  type: { type: String, required: true },
  attachmentType: { type: String, default: "Upload" }, // HotWorkPermit, ServiceOrder,...
  id: { type: String },
})

const emit = defineEmits(["add", "close"])

const { fetchAuthAsync } = useAuth()
const imgEl = ref(null)
const hasFiles = ref(false)
const id = toRef(props, "id")
const type = toRef(props, "type")
const attachmentType = toRef(props, "attachmentType")

const capture = (m) => {
  hasFiles.value = true
  imgEl.value.src = m
}

// duplicate to Attachments
const uploadFileAsync = async (f) => {
  if (type.value === "Standalone") {
    console.warn("Standalone operation.")
    hasFiles.value = false
    if (imgEl.value) {
      imgEl.value.src = ""
    }
    emit("add", f)
    return
  }

  startLoading("uploadFileAsync")
  try {
    const form = new FormData()
    form.append("file", f)
    const raw = await fetchAuthAsync(
      `${AZURE_URI}/Attachments/${type.value}/${id.value}?attachmentType=${attachmentType.value}`,
      "POST",
      form,
    )

    if (raw.status !== "ok" || !raw.attachment) {
      setError(raw)
    } else {
      hasFiles.value = false
      if (imgEl.value) {
        imgEl.value.src = ""
      }
      emit("add", raw.attachment)
    }
  } catch (e) {
    setError(e)
  }
  stopLoading("uploadFileAsync")
}

const uploadFiles = async () => {
  if (!hasFiles.value) {
    return
  }
  const now = dayjs().format("s-m-H-DD-MM-YY")
  const f = dataURLtoFile(imgEl.value.src, `slika-${now}.jpg`)
  if (!f) {
    console.error("Invalid file")
    return
  }
  await uploadFileAsync(f)
}

const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(",")
  if (arr.length !== 2) {
    console.error("Invalid data URL")
    return null
  }
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}
</script>
